import React from 'react';
import PropTypes from 'prop-types';
import { ErrorBoundary } from 'lib/components/ErrorBoundary/ErrorBoundary';
import { Header } from '../Header/Header';
import { Footer } from '../Footer/Footer';
import { WebSocketIndicator } from '../WebSocketIndicator/WebSocketIndicator';
import { DocumentHeadContainer } from '../DocumentHead/DocumentHeadContainer';
import { MainContainer, ContentContainer } from './MainLayout.styles';

export const MainLayout = ({ children }) => (
    <MainContainer>
        <ErrorBoundary>
            <Header />
        </ErrorBoundary>
        <ContentContainer>{children}</ContentContainer>
        <DocumentHeadContainer />
        <WebSocketIndicator />
        <Footer />
    </MainContainer>
);

MainLayout.propTypes = {
    children: PropTypes.node,
};

MainLayout.whyDidYouRender = true;
